module.exports = __webpack_public_path__ + "static/media/terminal.8d5de605.svg";